import React from 'react';
import Answer from './Answer.jsx';
// 解答の内容はここで編集
const AnswerField = (props) => {
    return (
        <>
            {/* <ScrollToTopOnMount /> */}
            {/* 質問に応じての答えを表示する */}
            {props.id==='1' &&
                <Answer id={props.id}
                        answer="３YTクラスは、４YTクラス進級への準備クラスですので特に入室条件はありません。" 
                        answer2="４YTクラスから上の学年につきましては、以下に挙げる所定の条件のいずれかを満たす方がお入り頂けます。" 
                        answer3="①	1月下旬～2月中旬実施の入室テストに合格した方" 
                        answer4="②	全国統一小学生テストで全教科総合偏差値が５８以上の方" 
                        answer5="③	土佐塾模擬テストのランキングに載っておられる方" 
                        // answer6="※条件に該当しない方でもお入り頂ける場合がありますので、担当者にご相談ください。" 
                />
            } 
            {props.id==='2' &&
                <Answer id={props.id}
                        answer="特にこれといった準備もなさらず、いきなり入会テストに来られる方の合格は難しいのが現状です。" 
                        answer2="ですから、遅くとも３年生の秋頃からご準備頂く必要がございます。入会テストの合格可能性を高める一番の近道は、小３ＹＴクラスにお入り頂くことです。" 
                        answer3="実際にＹＴクラスで教えている教員が、四谷大塚のテキストを用いて小４からの本格的なＹＴカリキュラムに備えた授業を行っています。" 
                        answer4="その他、ご家庭で出来る準備についても開示しておりますので、ご興味のある方は担当者にご相談ください。" 
                /> 
            }       
            {props.id==='3' &&
                <Answer id={props.id}
                        answer="カリキュラムの関係上、遅くとも４年生の秋頃までに入会していただくことがベストですが、ご本人の資質や家庭での学習状況により途中参加頂くことも可能ですので、担当者にご相談ください。" 
                /> 
            }
            {props.id==='4' &&
                <Answer id={props.id}
                        answer="授業を欠席した方にはセーフティメールを使って、その日の授業内容と宿題の有無をお知らせしていますのでご安心ください。" 
                        // answer2="※セーフティメールとは、土佐塾が保護者向けに生徒さんの入退室や授業内容・お知らせ・緊急連絡等をメールで配信している制度です。" 
                /> 
            }
            {props.id==='5' &&
                <Answer id={props.id} answer="ＹＴ教室では、授業以外の補習や個別指導・添削指導は全て無料で行っています。" /> 
            }
            {props.id==='6' &&
                <Answer id={props.id} answer="土佐塾模試は毎月受けて頂くことになります。受験費用は免除(小6の7月まで)となっています。" /> 
            }
            {props.id==='7' &&
                <Answer id={props.id} answer="全てオプションですので、参加は任意です。" /> 
            }
            {props.id==='8' &&
                <Answer id={props.id} 
                        answer="土佐塾模試や毎週末の週例テストが受験できないという方は、事前にお知らせくだされば振替受験※２可能です。体調不良等でそれすらも受験出来ない場合は、後日にテスト問題と解答解説をお渡し致します。" 
                        answer2="※２…金曜日の授業前後や土曜日の夕方に振替受験が可能です。"
                /> 
            }
            {props.id==='9' &&
                <Answer id={props.id} answer="組分けテストランクにおいてA組の上位(四谷偏差値44以上)であれば、次年度もＹＴでご継続頂けます。" /> 
            }
        </>
    )
}

export default AnswerField;